// Format masked currency value for validation and API
export const formatCurrencyToNumber = (
  value: Maybe<string>
): string | undefined => {
  if (!value) {
    return ''
  }

  return value.toString().replace(/\./g, '')
}
